import O1HD from "../../engines/gameEngine";
import utilsModel from "../../engines/libs/utilsModel";
import {EggSurpriseI, getEggSurpriseById} from "./config/EggSurpiseConfig";
import spendMode from "./spendMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GarBageEventShow extends cc.Component {

    @property({type:cc.Node,displayName:"cneter节点"})
    centerNode:cc.Node = null;
    @property({type:cc.Sprite,displayName:"icon图片"})
    sp_icon:cc.Sprite = null;
    @property({type:cc.Label,displayName:"描述文本"})
    lb_Dec:cc.Label = null;
    @property({type:cc.Prefab,displayName:"追投弹窗"})
    investmentPage:cc.Prefab = null;

    @property(cc.Node)
    btnNode1 : cc.Node = null;
    @property(cc.Node)
    btnNode2 : cc.Node = null;
    @property(cc.Node)
    btnNode3 : cc.Node = null;

    private mEggSurpriseConfig : EggSurpriseI;
    private mGameLayer : spendMode;


    start(){
    }

    bindEvent( id:string , gameLayer : spendMode ){
        this.mGameLayer = gameLayer;
        this.mEggSurpriseConfig = getEggSurpriseById( id );
        this.loadEvent();
    }

    loadEvent(){
        this.sp_icon.spriteFrame = null;
        // if( this.mEggSurpriseConfig.imgPath != null ){
        //     O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/Image/npc/${this.mEggSurpriseConfig.imgPath}`,cc.SpriteFrame,(err,sp:cc.SpriteFrame)=>{
        //         if(err){
        //             console.error(err,"加载icon失败");
        //         }else{
        //             this.sp_icon.spriteFrame = sp;
        //         }
        //     });
        // }
        return;

        let i = 0;
        for ( let chooseItem of this.mEggSurpriseConfig.chooseArray ) {
            if ( i == 0 ) {
                this._initBtnNode( this.btnNode1 , chooseItem );
            }else if ( i == 1 ){
                this._initBtnNode( this.btnNode2 , chooseItem );
            }else if ( i == 2 ){
                this._initBtnNode( this.btnNode3 , chooseItem );
            }
            i++;
        }

        // cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
        // this.scheduleOnce(,.5);
        this.updateChoose();
    }


    private _initBtnNode( chooseNode : cc.Node , chooseItem : { chooseName : string , value : number , watchVideoCount ?: number , content ?: string , coins ?: number }){
        chooseNode.active = true;
        chooseNode.getChildByName("lbName").getComponent(cc.Label).string = `${ chooseItem.chooseName }`;
        if (chooseItem.watchVideoCount && chooseItem.watchVideoCount == 1 ){
            chooseNode.getChildByName("Gksp").active = true;
        }
    }

    async updateChoose(){
        let dec:string = this.mEggSurpriseConfig.desc;
        for ( let i = 0 ; i < dec.length ; i++ ){
            let s = dec[i];
            this.lb_Dec.string += s;
            await new Promise<void>(resolve=>{
                this.scheduleOnce(resolve,.05);
            });
        }
    }

    /**
     *
     * @param e
     * @param cum
     */
    onBtnChoose( e:cc.Event.EventTouch,cum ){
        if ( e.target.getChildByName("Gksp").active ) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this._chooseCum( cum );
            },()=>{
               O1HD.getModules().uiControlModule.showMessageBox("观看视频失败",this.node );
            });
        }else{
            //
            this._chooseCum( cum );
        }
    }

    private _chooseCum( cum : string ){
        let chooseItem = this.mEggSurpriseConfig.chooseArray[Number(cum)];
        if ( chooseItem.coins != 0 ) {
            // 花钱
            this.mGameLayer.manage.setGameData({_coin:chooseItem.value},true);
        }

        if ( chooseItem.content ){
            this.mGameLayer.manage.setGameData({_coin:chooseItem.coins},true);
            O1HD.getModules().uiControlModule.showDialogBox(`海神事件`,chooseItem.content,false,( flag )=>{
                this.closeThis(()=>{
                    this.node.removeFromParent();
                    this.node.destroy();
                });
            });
        }else{
            this.closeThis(()=>{
                this.node.removeFromParent();
                this.node.destroy();
            });
        }
    }



    closeThis(complete?:()=>void){
        cc.tween(this.centerNode).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
        this.scheduleOnce(()=>{
            // console.log("11111>>>>>>>>>>")
            complete && complete()
        },.5);
    }

}
